import {HistoryStep} from "./historyStep";
import {HistoryController} from "./historyController";
import {IHistoryStep} from "./IHistoryStep";

export class HistoryStepForCallbacks extends HistoryStep implements IHistoryStep {
    private readonly undoFunction: () => void;
    private readonly redoFunction: () => void;

    public constructor(historyController: HistoryController, steptype: string, undoFunction: () => void, redoFunction: () => void) {
        super(historyController, {type: steptype, viewDetails: null});
        this.undoFunction = undoFunction;
        this.redoFunction = redoFunction;
    }

    redo(): void {
        this.redoFunction();
    }

    undo(): void {
        this.undoFunction();
    }

}